import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  link?: string;
}

interface NavigationPage { 
  title: string; 
  link: string; 
}

@Component({
  selector: 'app-assurance-marchandises-transportees',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-marchandises-transportees.component.html',
  styleUrls: ['./assurance-marchandises-transportees.component.scss']
})
export class AssuranceMarchandisesTransporteesComponent {
  title = 'Assurance Marchandises Transportées';
  subtitle = 'Protégez vos marchandises pendant leur transport';
  heroImage = 'assets/static_pages_images/marchandise.jpg';

  breadcrumbs: Breadcrumb[] = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Marchandises Transportées', link: undefined }
  ];

  prevPage: NavigationPage = { 
    title: 'Assurance Flotte Moto Professionnelle', 
    link: '/assurance-flotte-moto-professionnelle'
  };

  nextPage: NavigationPage = { 
    title: 'Assurance Transport', 
    link: '/assurance-transport'
  };
}
